import { assert_hash_sha256_not_empty, assert_string_not_empty, not_implemented_type } from '@shared/asserts/utils_asserts';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';
import { ENUM__grid2d_cell_size } from '@shared/dto/grid2d_cell/ENUM__grid2d_cell_size';
import { useMemo } from 'react';
import { use_slice_user } from '../../../../hooks/store/use_slices';

export function HOOK_GRID2D_CELL__get_url_relative(cell: DTO__grid2d_cell) {
  const { user_settings } = use_slice_user(['user_settings']);

  let out = useMemo(() => {
    let out = '';

    if (cell.image.is_stub()) return out;

    assert_hash_sha256_not_empty(cell.hash_sha256_content);
    assert_string_not_empty(cell.image.url_relative);
    assert_string_not_empty(cell.image.url_relative_small);

    switch (user_settings.ui_grid2d_cell_size) {
      case ENUM__grid2d_cell_size.XS:
      case ENUM__grid2d_cell_size.S:
      case ENUM__grid2d_cell_size.M:
        out = cell.image.url_relative_small;
        break;

      case ENUM__grid2d_cell_size.L:
      case ENUM__grid2d_cell_size.XL:
        out = cell.image.url_relative;
        break;
      default:
        not_implemented_type(user_settings.ui_grid2d_cell_size);
    }

    return out;
  }, [user_settings.ui_grid2d_cell_size, cell.image, cell.hash_sha256_content]);

  return out;
}
